import { Navigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useAuth } from "@/lib/auth";
import api from "@/lib/api";
import Sidebar from "@/components/Sidebar";
import Topbar from "@/components/Topbar";
import BottomNav from "@/components/BottomNav";

export default function Protected({ children }) {
  const { user, loading } = useAuth();
  const [sideOpen, setSideOpen] = useState(false);
  const loc = useLocation();
  const isEditor = /^\/app\/books\/[^/]+$/.test(loc.pathname);
  // Presence heartbeat — fire-and-forget every 60s + on route change.
  useEffect(() => {
    if (!user) return;
    const beat = () => api.post("/heartbeat", { page: loc.pathname }).catch(()=>{});
    beat();
    const t = setInterval(beat, 60000);
    return () => clearInterval(t);
  }, [user, loc.pathname]);
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="loading-state">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace/>;
  return (
    <div className="flex min-h-screen bg-[#080B12]">
      <Sidebar open={sideOpen} onClose={() => setSideOpen(false)}/>
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar onToggleSidebar={() => setSideOpen(true)}/>
        <main className={`flex-1 min-w-0 ${isEditor ? "" : "pb-[calc(4rem+env(safe-area-inset-bottom))] lg:pb-0"}`}>{children}</main>
      </div>
      <BottomNav/>
    </div>
  );
}
